/* globals removeElementURL, replaceURL, autocomplete, changeURL */
/* eslint no-global-assign: 0 */
bz_app.directive('permitMap', [
  '$rootScope',
  '$timeout',
  'buildingPermitModel',
  'propertiesService',
  'propertySearchService',
  'zoomService',
  'markerService',
  'geolocationService',
  'trackPermitMapService',
  function (
    $rootScope,
    $timeout,
    buildingPermitModel,
    propertiesService,
    propertySearchService,
    zoomService,
    markerService,
    geolocationService,
    trackPermitMapService
  ) {
    //nationwide lat and long
    var nationalLatitude = 37.09024
    var nationalLongitude = -95.71289100000001
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        latitude: '@',
        longitude: '@',
        zoom: '@',
      },
      template: '<div id="main_map"></div>',
      link: function (scope, element, attrs) {
        var el = document.createElement('div')
        el.style.width = '100%'
        el.style.height = '100%'
        element.prepend(el)
        scope.is_nationwide = attrs.query == 'nation-wide'

        var latitude = attrs.latitude || nationalLatitude
        var longitude = attrs.longitude || nationalLongitude
        var mapOptions = {
          center: new google.maps.LatLng(latitude, longitude),
          sensor: true,
          scrollwheel: false,
          zoom: 14,
          styles: bzGlobal.map.style,
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
        }

        var initializeMap = function (mapOptions) {
          var map = new google.maps.Map(el, mapOptions)
          scope.map = map
          zoomService.registerEventListeners()
          loadAutocomplete()
          $rootScope.$broadcast('mapInitialized', map)
        }

        var loadNationwideView = function () {
          resetMap()
          scope.is_nationwide = true
          changeUrlToNationwide()
          centerMap(nationalLatitude, nationalLongitude)
          propertiesService.resetParams(['lat', 'lng', 'full_address'])
          propertiesService.addNationwideClusters(scope.map)
        }

        var changeUrlToNationwide = function () {
          var cityPath = location.pathname.split('/')[2]
          removeElementURL('zoom')
          replaceURL(cityPath, 'nation-wide')
        }

        var setQueryFieldToCityState = function () {
          var path = location.pathname.split('/')[2].toLowerCase()
          var query = path.split('-')
          var unique = [
            'los-angeles-ca',
            'chicago-il',
            'houston-tx',
            'miami-fl',
            'seattle-wa',
          ]
          if (unique.join(' ').indexOf(path) < 0) {
            var state = query.pop()
            propertySearchService.query = (
              query.join(' ') +
              ', ' +
              state
            ).toUpperCase()
          } else {
            propertySearchService.query = query.join(' ').toUpperCase()
          }
        }

        var loadInitialMarkers = function () {
          //set API to use existing params
          propertiesService.loadParams()

          if (getURLParameter('lat')) scope.latitude = getURLParameter('lat')
          if (getURLParameter('lng')) scope.longitude = getURLParameter('lng')
          if (getURLParameter('full_address')) {
            propertySearchService.query = getURLParameter('full_address')
              .replace(/-/g, ' ')
              .toUpperCase()
          } else if (
            location.pathname.split('/')[2] != '' &&
            typeof location.pathname.split('/')[2] != 'undefined'
          ) {
            setQueryFieldToCityState()
          }
          centerMap(scope.latitude, scope.longitude)
          //set zoom
          if (getURLParameter('zoom')) {
            zoomService.changeZoom(getURLParameter('zoom'))
          } else if (getURLParameter('full_address')) {
            zoomService.setMicroNeighborhoodZoom()
          }
          propertySearchService.loadParams()

          if (
            propertySearchService.permitAttributeOption &&
            propertySearchService.permitAttributeOption.id
          ) {
            scope.permitAttribute = propertySearchService.permitAttributeOption
          }
          loadPropertiesFromAPI()
        }

        var centerMap = function (lat, lng) {
          scope.map.setCenter(new google.maps.LatLng(lat, lng))
          scope.latitude = lat
          scope.longitude = lng
        }

        $rootScope.$on('permit_map.center', function (e, lat, lng) {
          centerMap(lat, lng)
        })

        var resetMap = function () {
          propertiesService.clearMap(scope.map)
        }

        var loadAutocomplete = function () {
          let input = document.getElementById('permit-map-query')

          autocomplete = new google.maps.places.Autocomplete(input, {
            componentRestrictions: { country: 'us' },
            types: ['address'],
            fields: [
              'address_components',
              'adr_address',
              'formatted_address',
              'geometry',
              'icon',
              'name',
              'place_id',
            ],
          })

          google.maps.event.addListener(
            autocomplete,
            'place_changed',
            function () {
              $('.btn-search').click()
            }
          )
        }

        var usePermitAttributeOption = function () {
          return (
            propertySearchService &&
            propertySearchService.permitAttributeOption &&
            propertySearchService.permitAttributeOption.name !== 'All Projects'
          )
        }

        var loadPropertiesFromAPI = function () {
          $rootScope.in_progress = true
          if (scope.latitude) propertiesService.setLatitude(scope.latitude)
          if (scope.longitude) propertiesService.setLongitude(scope.longitude)
          if (scope.full_address)
            propertiesService.setFullAddress(scope.full_address)
          if (usePermitAttributeOption())
            propertiesService.setPermitAttribute(
              propertySearchService.permitAttributeOption
            )
          if (!usePermitAttributeOption() && scope.permitAttribute)
            propertiesService.setPermitAttribute(scope.permitAttribute)
          if (getURLParameter('zoom')) {
            propertiesService.setLatLngParams(scope.latitude, scope.longitude)
          }
          resetMap()
          propertiesService.addPinsToMapFromAPI(
            scope.map,
            bzGlobal.map.marker.circle.unselected,
            {},
            true
          )
        }

        $rootScope.$on('permit_map.search', function (e) {
          if (zoomService.currentGoogleLevel) {
            changeURL('zoom', zoomService.currentGoogleLevel)
          }
          loadPropertiesFromAPI()
        })

        scope.$on('properties.allPinsFromInputLoaded', function (event) {
          // Initial pins added to map and list, query in more pins
          if (!scope.is_nationwide) {
            loadPropertiesFromAPI()
          }
          // Time to add any custom pins (no property link)
          // if (propertiesService.active_pin) {
          //	 propertiesService.activatePin(propertiesService.active_pin);
          // }
        })

        scope.$on('properties.clusterClicked', function (event, args) {
          scope.is_nationwide = false
          var cluster = args.getMarkers()[0]
          scope.latitude = cluster.position.lat()
          scope.longitude = cluster.position.lng()
          replaceURL('-wide', cluster.link)
          centerMap(scope.latitude, scope.longitude)
          zoomService.changeZoom(10)
          loadPropertiesFromAPI()
        })

        scope.$on('zoom.clicked', function (event, is_nationwide) {
          scope.is_nationwide = is_nationwide
          if (!scope.is_nationwide) {
            loadPropertiesFromAPI()
          } else {
            loadNationwideView()
          }
        })

        scope.$on('zoom-property', function (event, property, skipAPI) {
          zoomAddress(property, skipAPI)
        })

        //property can be either (1) property object; or (2) search object from Google Maps
        var zoomAddress = function (property, skipAPI) {
          //if zoom on different address
          if (
            scope.latitude !== property.latitude &&
            scope.longitude !== property.longitude
          ) {
            latitude = scope.latitude = property.latitude
            longitude = scope.longitude = property.longitude
            //search object has street_number attribute if search included street_number
            //property object has alias
            if (
              property.street ||
              (property.street_address &&
                property.street_address.replace(/ /g, ''))
            ) {
              zoomService.setMicroNeighborhoodZoom()
            } else {
              zoomService.changeZoom(14)
            }
            scope.is_nationwide = false
            centerMap(property.latitude, property.longitude)
            if (skipAPI !== true) {
              if (property.alias) {
                propertiesService.setParam('full_address', property.alias)
              }
              loadPropertiesFromAPI()
            }
            //do nothing
          } else {
            $rootScope.in_progress = false
          }
        }

        scope.$on('geolocate', function (event) {
          $rootScope.in_progress = true
          propertiesService.removeCityPath()
          trackPermitMapService.clickGeolocate()
          geolocationService.getLocationFromGPS(function (position) {
            zoomAddress(position.coords)
            trackPermitMapService.geolocateSuccess()
          })
        })

        scope.$on('user_location_set_error', function (event, error) {
          $rootScope.$apply(function () {
            $rootScope.in_progress = false
          })
        })

        scope.$on(
          'permitMapCtrl.queryAddress.success',
          function (event, searchResult) {
            zoomAddress(searchResult)
          }
        )

        google.maps.event.addDomListener(window, 'resize', function () {
          centerMap(scope.latitude, scope.longitude)
        })

        google.maps.event.addDomListener(
          window,
          'load',
          initializeMap(mapOptions)
        )

        google.maps.event.addListenerOnce(scope.map, 'idle', function (event) {
          if (scope.is_nationwide) {
            // loadNationwideView();
            zoomService.setNationalZoom()
          } else {
            loadInitialMarkers()
          }
        })

        google.maps.event.addListener(scope.map, 'bounds_changed', function () {
          // centerMap(scope.latitude, scope.longitude);
        })

        google.maps.event.addListener(scope.map, 'dblclick', function (e) {
          var lat = e.latLng.lat()
          var lng = e.latLng.lng()
          centerMap(lat, lng)
          propertiesService.setLatLngParams(lat, lng)
          zoomService.zoomIn()
        })

        google.maps.event.addListener(scope.map, 'dragstart', function () {
          $rootScope.$broadcast('dragstart', scope.map)
        })

        google.maps.event.addListener(scope.map, 'dragend', function () {
          var center = scope.map.getCenter()
          scope.latitude = center.lat()
          scope.longitude = center.lng()
        })

        google.maps.event.addListener(scope.map, 'idle', function () {
          $rootScope.$broadcast('mapidle', scope.map)
        })
      },
    }
  },
])
